import { Intent } from '@blueprintjs/core'
import React, { MouseEvent, SFC } from 'react'

import { Button } from '../../shared'

type Props = {
  active?: boolean
  disabled?: boolean
  navigation?: boolean
  page: number
  'data-test'?: string
  onClick(page: number): void
}

const PaginationButton: SFC<Props> = ({
  active = false,
  disabled = false,
  page,
  children,
  onClick,
  navigation,
  ...rest
}) => {
  return (
    <Button
      className={active ? '' : 'bp3-minimal'}
      intent={active || (navigation && !disabled) ? Intent.PRIMARY : Intent.NONE}
      disabled={disabled}
      onClick={handleClick}
      {...rest}
    >
      {children}
    </Button>
  )

  function handleClick(ev: MouseEvent<HTMLElement>): void {
    ev.preventDefault()
    const allowPageChange = !(disabled || active)
    allowPageChange && onClick(page)
  }
}

export { PaginationButton }



// WEBPACK FOOTER //
// ./src/app/shared/pagination/pagination-button.tsx